import { useFavorite } from '@/js/vue/composable/favorite.ts';

export function initFavorite(): void {
  const buttons = document.querySelectorAll<HTMLButtonElement>('.js-favorite-toggle');

  for (const btn of buttons) {
    btn.addEventListener('click', () => {
      void handleFavoriteToggle(btn);
    });
  }
}

const { add, remove } = useFavorite();

async function handleFavoriteToggle(btn: HTMLButtonElement): Promise<void> {
  const productId = Number(btn.dataset.productId);

  if (btn.classList.contains('active')) {
    await remove(productId);
    btn.classList.remove('active');
  }
  else {
    await add(productId);
    btn.classList.add('active');
  }
}
